import { useNearlyExpiredMedicine } from './ContextAPI';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';

export default function Index() {
    const { showPdf } = useNearlyExpiredMedicine();

    return showPdf ? <PrintIndex /> : <FormInfo />;
}
